/* ===== PartFay — الطلب الخاص =====
   كل الطلبات تذهب لمسارات Shopify الأصلية فقط (/cart/add.js · /cart/update.js · /cart.js · /checkout).
   1) «اطلبها الآن — طلب خاص»: إقرار ← إضافة للسلة الحقيقية ← الدفع (أو السلة إن كانت مختلطة).
   2) إقرار الطلب الخاص قبل متابعة الدفع من صفحة السلة والدرج.
   3) رقم الهيكل: تحقق من الصيغة فقط ثم إرسال للقناة الفعلية — بلا أي تأكيد توافق تلقائي. */
(function () {
  'use strict';

  var $  = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  var cfg = {};
  try { cfg = JSON.parse(($('#pf-so-config') || {}).textContent || '{}'); } catch (e) { cfg = {}; }
  var T = cfg.t || {};
  var routes = (window.PF_CONFIG && window.PF_CONFIG.routes) || {};
  var ROOT = (routes.root || '/').replace(/\/?$/, '/');

  function toast(msg, kind) { if (window.pfToast) window.pfToast(msg, kind); }

  function jsonFetch(url, opts) {
    return fetch(url, opts).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || T.error || '');
        return j;
      });
    });
  }

  /* ---------- 1) نافذة «اطلبها الآن» ---------- */
  function initBuyNow() {
    var trigger = $('[data-so-buynow]');
    var sheet = $('[data-so-sheet]');
    var overlay = $('[data-so-overlay]');
    if (!trigger || !sheet) return;

    var form = trigger.closest('form');
    var ack = $('[data-so-sheet-ack]', sheet);
    var err = $('[data-so-sheet-err]', sheet);
    var go = $('[data-so-sheet-go]', sheet);
    var goLabel = go ? go.textContent : '';
    var lastFocus = null;

    function onKey(e) {
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab') return;
      var items = $$('a[href],button:not([disabled]),input:not([disabled])', sheet).filter(function (el) { return el.offsetParent !== null; });
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    function open() {
      if (trigger.disabled) return;
      lastFocus = document.activeElement;
      if (err) err.hidden = true;
      ack.closest('.pf-so-ack').classList.remove('is-err');
      sheet.setAttribute('open', '');
      sheet.setAttribute('aria-hidden', 'false');
      if (overlay) overlay.setAttribute('open', '');
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', onKey);
      setTimeout(function () { ack.focus({ preventScroll: true }); }, 80);
    }

    function close() {
      if (!sheet.hasAttribute('open')) return;
      sheet.removeAttribute('open');
      sheet.setAttribute('aria-hidden', 'true');
      if (overlay) overlay.removeAttribute('open');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onKey);
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }

    function busy(on) {
      if (!go) return;
      go.disabled = on;
      go.setAttribute('aria-busy', on ? 'true' : 'false');
      go.textContent = on ? (T.processing || goLabel) : goLabel;
    }

    function proceed() {
      if (!ack.checked) {
        if (err) err.hidden = false;
        ack.closest('.pf-so-ack').classList.add('is-err');
        ack.focus();
        return;
      }
      busy(true);
      var fd = new FormData(form);
      var attrs = {};
      if (cfg.ackAttr) attrs[cfg.ackAttr] = cfg.ackValue || 'نعم';
      if (cfg.mixedAttr) attrs[cfg.mixedAttr] = '';   // تُعاد كتابتها من صفحة السلة إن كانت السلة مختلطة

      jsonFetch((routes.cartAdd || '/cart/add') + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd })
        .then(function () {
          return jsonFetch(ROOT + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ attributes: attrs })
          });
        })
        .then(function (cart) {
          // سلة مختلطة؟ نعرض صفحة السلة أولًا ليرى العميل مدة كل نوع وسياسة الشحن
          var mixed = (cart.items || []).some(function (it) {
            var p = it.properties || {};
            return !(cfg.propType && p[cfg.propType] === cfg.typeVal) && cfg.specialIds.indexOf(it.product_id) === -1;
          });
          window.location.href = mixed ? (routes.cart || '/cart') : ROOT + 'checkout';
        })
        .catch(function (e) {
          busy(false);
          toast(e.message || T.error, 'error');
        });
    }

    trigger.addEventListener('click', open);
    $$('[data-so-sheet-close]', sheet).forEach(function (b) { b.addEventListener('click', close); });
    if (overlay) overlay.addEventListener('click', close);
    if (go) go.addEventListener('click', proceed);
    ack.addEventListener('change', function () {
      if (ack.checked) { if (err) err.hidden = true; ack.closest('.pf-so-ack').classList.remove('is-err'); }
    });

    // مزامنة زر «اطلبها الآن» والسعر مع الخيار المحدد (يحدّثه theme.js على زر الإضافة)
    var addBtn = form && $('[data-add-btn]', form);
    function sync() {
      if (addBtn) trigger.disabled = addBtn.disabled;
      var p1 = $('[data-variant-price]'), p2 = $('[data-so-sheet-price]', sheet);
      if (p1 && p2) {
        var main = p1.childNodes[0];
        p2.textContent = (main && main.nodeType === 3 ? main.textContent : p1.textContent).trim();
      }
      var sku = $('[data-variant-sku]'), skuIn = $('[data-so-vin-sku]'), wa = $('[data-so-vin-wa]');
      if (sku && skuIn) skuIn.value = sku.textContent.trim();
      if (sku && wa) wa.setAttribute('data-sku', sku.textContent.trim());
    }
    $$('[data-option]', form || document).forEach(function (s) {
      s.addEventListener('change', function () { setTimeout(sync, 0); });
    });
  }

  /* ---------- 2) الإقرار في السلة والدرج ---------- */
  var lastSubmitter = null;
  function initCartAck() {
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('button[type="submit"],input[type="submit"]');
      if (b) lastSubmitter = b;
    }, true);

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches || !form.matches('[data-so-cart-form][data-so-required]')) return;
      var sub = e.submitter || lastSubmitter;
      if (sub && sub.form === form && sub.name !== 'checkout') return;   // تحديث الملاحظة… لا يحتاج إقرار
      var ack = $('[data-so-ack]', form);
      if (!ack || ack.checked) return;
      e.preventDefault();
      var err = $('[data-so-ack-err]', form);
      if (err) err.hidden = false;
      var label = ack.closest('.pf-so-ack');
      if (label) {
        label.classList.add('is-err');
        label.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
      ack.focus({ preventScroll: true });
    }, true);

    document.addEventListener('change', function (e) {
      var ack = e.target;
      if (!ack.matches || !ack.matches('[data-so-ack]')) return;
      var form = ack.closest('form');
      var label = ack.closest('.pf-so-ack');
      if (label) label.classList.toggle('is-err', false);
      var err = form && $('[data-so-ack-err]', form);
      if (err && ack.checked) err.hidden = true;
      var express = form && $('[data-so-express]', form);
      if (express) express.classList.toggle('pf-so-express-lock', !ack.checked);
    });
  }

  /* ---------- 3) رقم الهيكل ---------- */
  var VIN_RE = /^[A-HJ-NPR-Z0-9]{17}$/;
  function normVin(v) {
    return String(v || '')
      .replace(/[٠-٩]/g, function (d) { return d.charCodeAt(0) - 0x0660; })
      .replace(/[۰-۹]/g, function (d) { return d.charCodeAt(0) - 0x06F0; })
      .replace(/[\s\-_.]/g, '')
      .toUpperCase();
  }
  function checkVin(input, errEl) {
    var v = normVin(input.value);
    input.value = v;
    var ok = VIN_RE.test(v);
    input.setAttribute('aria-invalid', ok ? 'false' : 'true');
    if (errEl) errEl.hidden = ok;
    if (!ok) input.focus();
    return ok;
  }

  function initVin() {
    var box = $('[data-so-vin]');
    if (!box) return;

    // بعد إرسال نموذج التواصل يعود Shopify لنفس الصفحة: نفتح القسم ونُظهر الرسالة
    if ($('[data-so-vin-posted]', box)) {
      box.open = true;
      setTimeout(function () { box.scrollIntoView({ block: 'center' }); }, 120);
    }

    $$('[data-so-vin-input]', box).forEach(function (inp) {
      inp.addEventListener('input', function () {
        var n = normVin(inp.value).slice(0, 17);
        if (n !== inp.value) inp.value = n;
        if (inp.getAttribute('aria-invalid') === 'true' && VIN_RE.test(normVin(inp.value))) {
          inp.setAttribute('aria-invalid', 'false');
          var err = $('[data-so-vin-err]', inp.closest('.pf-field'));
          if (err) err.hidden = true;
        }
      });
    });

    var form = $('[data-so-vin-form]', box);
    if (form) {
      form.addEventListener('submit', function (e) {
        var inp = $('[data-so-vin-input]', form);
        if (!checkVin(inp, $('[data-so-vin-err]', form))) { e.preventDefault(); return; }
        var email = $('input[type="email"]', form);
        if (email && !email.checkValidity()) { e.preventDefault(); email.reportValidity(); }
      });
    }

    var wa = $('[data-so-vin-wa]', box);
    if (wa) {
      var send = $('[data-so-vin-send]', wa);
      send.addEventListener('click', function () {
        var inp = $('[data-so-vin-input]', wa);
        if (!checkVin(inp, $('[data-so-vin-err]', wa))) return;
        var lines = [
          wa.getAttribute('data-msg'),
          (T.product || 'القطعة') + ': ' + wa.getAttribute('data-product'),
          wa.getAttribute('data-sku') ? (T.sku || 'رقم القطعة') + ': ' + wa.getAttribute('data-sku') : '',
          (T.vin || 'رقم الهيكل') + ': ' + inp.value,
          wa.getAttribute('data-url')
        ].filter(Boolean);
        var num = (wa.getAttribute('data-wa') || '').replace(/[^0-9]/g, '');
        if (!num) return;
        window.open('https://wa.me/' + num + '?text=' + encodeURIComponent(lines.join('\n')), '_blank', 'noopener');
      });
    }
  }

  function boot() {
    cfg.specialIds = cfg.specialIds || [];
    initBuyNow(); initCartAck(); initVin();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
